export const PeriodList = (limit, type,onlyYear) => {
    let currentYear,
        periodList = [],
        modifiedYear;
    currentYear = new Date().getFullYear();
    for (let i = 0; i < limit; i++) {
        modifiedYear = currentYear - i;
        if(onlyYear){
            periodList.push({
                label: `${modifiedYear}`,
                value: `${modifiedYear}`
            }
            )

        }
        else{
            if (type === 'half') {
                periodList.push({
                    label: `${modifiedYear}-H1`,
                    value: `${modifiedYear}-H1`
                },
                    {
                        label: `${modifiedYear}-H2`,
                        value: `${modifiedYear}-H2`
                    }
                )
    
    
            }
            else if (type === 'full') {
                periodList.push({
                    label: `${modifiedYear}-H1`,
                    value: `${modifiedYear}-H1`
                },
    
                    {
                        label: `${modifiedYear}-H2`,
                        value: `${modifiedYear}-H2`
                    },
                    {
                        label: `${modifiedYear}-Q1`,
                        value: `${modifiedYear}-Q1`
                    },
                    {
                        label: `${modifiedYear}-Q2`,
                        value: `${modifiedYear}-Q2`
                    },
                    {
                        label: `${modifiedYear}-Q3`,
                        value: `${modifiedYear}-Q3`
                    },
                    {
                        label: `${modifiedYear}-Q4`,
                        value: `${modifiedYear}-Q4`
                    },
                )
    
            }
        }
    }
    return periodList;


}